export type TemplateAssignationStatus =
  | "no-tags"
  | "default-tags"
  | "user-assigned-tags";

export enum MailHost {
  OFFICE = 0,
  GMAIL = 1,
}

export enum StepperStateKey {
  MAILING_PERMISSIONS = 0,
  PROVISION_ONE_USER = 1,
  SIMULATION_DELIVERY_TEST = 2,
  ATTRIBUTE_TEMPLATES_DEPARTMENTS = 3,
  REPORT_BUTTON_DEPLOYMENT = 4,
}

export type ServiceAccountStatus = {
  is_set_up: boolean;
  unique_id: string | null;
  email: string | null;
};

export type SimulationSetupChecklistStatus = {
  mail_host: MailHost;
  has_mail_permissions: boolean;
  has_provisioning_permissions: boolean;
  has_at_least_one_non_admin_user: boolean;
  delivery_tests: {};
  assign_templates_to_departments: TemplateAssignationStatus;
  has_confirmed_all_delivery_tests: boolean;
  has_report_button_deployment: boolean;
  service_account_status: ServiceAccountStatus;
};
